<template>
    <div class="unionContent flex">
        <div class="treeBox flex">
            <div class="treeOne column">
                <div :class="['oneItem column',oneActive == index ? 'oneItemOn' : '']" v-for="(item,index) in 20" :key="index">
                    <el-image :src="require('@/assets/icon/footBtn01.png')" fit="cover" class="oneIcon"></el-image>
                    <div class="oneName">数据</div>
                </div>
            </div>
            <div class="treeTwoBox column">
                <el-image :src="require('@/assets/icon/union.png')" fit="cover" class="twoIcon"></el-image>
                <div class="treeTwo">
                    <el-tree :data="terrData" :props="defaultProps" accordion icon-class=" " @node-click="handleNodeClick">
                        <template #default="{node, data}">
                            <template v-if="node.level === 1">
                                <div class="twoBox align">
                                    <el-image v-if="node.expanded && node.level==1" :src="data.icon" fit="cover" class="twoIcon"></el-image>
                                    <el-image v-else :src="data.iconOn" fit="cover" class="twoIcon"></el-image>
                                    <span :class="['twoName',node.expanded && node.level==1 ? 'twoNameOn' : '']">{{ data.label }}</span>
                                </div>
                            </template>
                            <template v-else-if="node.level === 2">
                                <div class="twoBox align">
                                    <span :class="['twoName',node.isCurrent && node.level==2 ? 'twoNameOn' : '']">{{ data.label }}</span>
                                </div>
                            </template>
                        </template>
                    </el-tree>
                </div>
            </div>
        </div>
        <div class="unionBox">
            <div class="unionTop spb">
                <div class="foldBox center">
                    <el-image :src="require('@/assets/icon/fold.png')" fit="cover" class="fold"></el-image>
                </div>
                <div class="floatList align">
                    <div class="floatBox align">
                        <el-image :src="require('@/assets/icon/float01.png')" fit="cover" class="floatIcon"></el-image>
                        <div class="floatName">联系客服</div>
                    </div>
                    <div class="line"></div>
                    <div class="floatBox align">
                        <el-image :src="require('@/assets/icon/float01.png')" fit="cover" class="floatIcon"></el-image>
                        <div class="floatName">活动公告</div>
                    </div>
                    <div class="line"></div>
                    <div class="floatBox align">
                        <el-image :src="require('@/assets/icon/float01.png')" fit="cover" class="floatIcon"></el-image>
                        <div class="floatName">小程序</div>
                    </div>
                    <el-image :src="require('@/assets/icon/suc.png')" fit="cover" class="head"></el-image>
                </div>
            </div>
            <div class="unionBottom">
                <div class="unionTabBox between">
                    <div class="unionTabList flex">
                        <div :class="['unionTab',tabActive == index ? 'unionTabOn' : '']" v-for="(item,index) in tabData" :key="index">{{ item }}</div>
                    </div>
                    <el-input v-model="searchKey" placeholder="请输入内容" class="search"></el-input>
                </div>
                <div class="unionList flex">
                    <div class="unionItem" v-for="(item,index) in 10" :key="index">
                        <div class="imgBox">
                            <el-image :src="require('@/assets/image/fission.png')" fit="cover" class="itemImg"></el-image>
                            <div class="itemId">活动ID:4</div>
                        </div>
                        <div class="itemBox">
                            <div class="title" title="网约车&代驾CPA+CPS活动">网约车&代驾CPA+CPS活动</div>
                            <div class="commission">佣金<span class="commissionNum">最高60元</span></div>
                            <div class="time">结算时间:次月20号</div>
                            <div class="spb">
                                <div class="unionBtn">活动说明</div>
                                <div class="unionBtn unionBtnOn">立即推广</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return {
                oneActive: 0,
                terrData: [
                    {
                        label: '一级 1',
                        icon: 'http://hehuorenyun.vfengyun.cn/uploads/20231228/0685ac37f3985f2e9bd1211e09ef9f39.png',
                        iconOn: 'http://hehuorenyun.vfengyun.cn/uploads/20231228/4392ec296fa2ce57e7110dfbfa16cf7a.png',
                        children: [{
                            label: '二级 1-1'
                        }]
                    }, {
                        label: '一级 2',
                        icon: 'http://hehuorenyun.vfengyun.cn/uploads/20231228/0685ac37f3985f2e9bd1211e09ef9f39.png',
                        iconOn: 'http://hehuorenyun.vfengyun.cn/uploads/20231228/4392ec296fa2ce57e7110dfbfa16cf7a.png',
                        children: [{
                            label: '二级 2-1'
                        }, {
                            label: '二级 2-2'
                        }]
                    }, {
                        label: '一级 3',
                        icon: 'http://hehuorenyun.vfengyun.cn/uploads/20231228/0685ac37f3985f2e9bd1211e09ef9f39.png',
                        iconOn: 'http://hehuorenyun.vfengyun.cn/uploads/20231228/4392ec296fa2ce57e7110dfbfa16cf7a.png',
                        children: [{
                            label: '二级 3-1'
                        }, {
                            label: '二级 3-2'
                        }]
                    }
                ],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                tabData: ['标题','标题','标题','标题','标题'],
                tabActive: 0,
                searchKey: ''
            }
        },
        created(){
            
        },
        methods: {
            handleNodeClick(data,node) {
                console.log(data,node);
            },
        }
    }
</script>
<style lang="less" scoped>
    .unionContent{
        width: 100vw;
        height: 100vh;
        background: #F2F4F7;
        .treeBox{
           width: 304px;
           height: 100vh;
           margin-right: 24px;
           .treeOne{
                width: 64px;
                padding-top: 114px;
                height: calc(100vh - 114px);
                background: #000;
                overflow-y: scroll;
                scrollbar-width: none;
                .oneItem{
                    width: 54px;
                    height: 54px;
                    border-radius: 4px;
                    margin-bottom: 16px;
                    cursor: pointer;
                    .oneIcon{
                        width: 24px;
                        height: 24px;
                    }
                }
                .oneItemOn{
                    background: #FF601C;
                }
                .oneName{
                    font: 14px/18px "Microsoft YaHei";
                    color: #fff;
                    margin-top: 3px;
                }
           }
           /deep/ .el-tree-node__content{
                height: 56px;
                margin-bottom: 8px;
                border-radius: 4px;
            }
           .treeTwoBox{
                width: 240px;
                height: 100vh;
                background: #fff;
                .twoIcon{
                    width: 176px;
                    height: 57px;
                    margin-top: 28px;
                }
                .treeTwo{
                    width: 208px;
                    padding: 30px 0;
                    height: calc(100vh - 145px);
                    overflow-y: scroll;
                    scrollbar-width: none;
                    .twoBox{
                        width: 184px;
                        height: 56px;
                        padding: 0 12px;
                        border-radius: 4px;
                        
                        .twoIcon{
                            width: 24px;
                            height: 24px;
                            margin: 0;
                        }
                        .twoName{
                            font: 14px/18px "Microsoft YaHei";
                            color: #161825;
                            margin-left: 8px;
                        }
                        .twoNameOn{
                            color: #FF601C;
                        }
                    }
                }
           }
        }
        .unionBox{
            flex: 1;
            height: 100vh;
            .unionTop{
                padding: 25px 0;
                .foldBox{
                    width: 53px;
                    height: 53px;
                    background: #fff;
                    border-radius: 8px;
                    cursor: pointer;
                    .fold{
                        width: 24px;
                        height: 24px;
                    }
                }
                .floatList{
                    padding: 0 10px;
                    height: 52px;
                    border-radius: 26px;
                    background: #fff;
                    .floatBox{
                        padding: 0 10px;
                        height: 34px;
                        border-radius: 17px;
                        cursor: pointer;
                        .floatIcon{
                            width: 24px;
                            height: 24px;
                        }
                        .floatName{
                            font: 14px/18px "Microsoft YaHei";
                            color: #161825;
                            margin-left: 2px;
                        }
                    }
                    .line{
                        width: 1px;
                        height: 12px;
                        background: #EBEBEB;
                        margin: 0 8px;
                    }
                    .head{
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        margin-left: 26px;
                    }
                }
            }
            .unionBottom{
                width: 100%;
                height: calc(100vh - 103px);
                background: #fff;
                border-radius: 4px;
                .unionTabBox{
                    padding: 14px 32px 0 32px;
                    border-bottom: 1px solid #EBEBEB;
                    .unionTabList{
                        margin-bottom: -1px;
                        .unionTab{
                            font: 16px/56px "Microsoft YaHei";
                            margin-left: 56px;
                            padding-bottom: 1px;
                            cursor: pointer;
                            &:first-child{
                                margin: 0;
                            }
                        }
                        .unionTabOn{
                            color: #FF601C;
                            border-bottom: 1px solid #FF601C;
                            padding: 0;
                        }
                    }
                    .search{
                        width: 320px;
                        height: 40px;
                        /deep/ .el-input__inner {
                            border: none;
                            background: #F5F5F5;
                            border-radius: 20px;
                            padding: 0 24px;
                        }
                    }
                }
                .unionList{
                    padding: 24px;
                    max-height: calc(100vh - 224px);
                    overflow-y: scroll;
                    scrollbar-width: none;
                    .unionItem{
                        width: 237px;
                        height: 270px;
                        background: #fff;
                        box-shadow: 0px 2px 22px 0px rgba(0,0,0,0.05);
                        border-radius: 8px;
                        margin: 7px;
                        .imgBox{
                            width: 237px;
                            height: 120px;
                            position: relative;
                            .itemImg{
                                width: 237px;
                                height: 120px;
                                border-radius: 8px 8px 0 0;
                            }
                            .itemId{
                                padding: 0 6px;
                                height: 24px;
                                background: rgba(0,0,0,0.45);
                                border-radius: 0 8px 0 0;
                                font: 14px/24px "Microsoft YaHei";
                                color: #fff;
                                position: absolute;
                                left: 0;
                                bottom: 0;
                            }
                        }
                        .itemBox{
                            padding: 10px 16px 16px 16px;
                            .title{
                                font: bold 16px/22px "Microsoft YaHei";
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                            }
                            .commission{
                                font: 14px/26px "Microsoft YaHei";
                                color: #161825;
                                margin-top: 10px;
                                .commissionNum{
                                    font: bold 20px/26px "Microsoft YaHei";
                                    color: #ff601c;
                                    margin-left: 4px;
                                }
                            }
                            .time{
                                    font: 12px/16px "Microsoft YaHei";
                                    color: #73727a;
                                    margin: 4px 0 12px 0;
                                }
                                .unionBtn{
                                    width: 96px;
                                    height: 30px;
                                    border-radius: 4px;
                                    border: 1px solid #E6E6E6;
                                    font: 14px/32px "Microsoft YaHei";
                                    color: #161825;
                                    text-align: center;
                                    cursor: pointer;
                                }
                                .unionBtnOn{
                                    border: 1px solid #ff601c;
                                    color: #ff601c;
                                }
                        }
                    }
                }
            }
        }
    }
</style>